import {
    DarkVenueHeatmapApiOkResponse,
    DarkVenueHeatmapApiResponse,
    isErrorResponse,
} from './DarkVenueHeatmapApiResponse';

export type ValidateResponse = {
    isValid: boolean;
    error?: { message: string; data: unknown };
};
const fail: (message: string, data?: unknown) => ValidateResponse = (
    message,
    data
) => ({
    isValid: false,
    error: { message, data },
});

export function validateResponse(
    response: DarkVenueHeatmapApiResponse
): ValidateResponse {
    if (isErrorResponse(response)) {
        return fail(response.message);
    }

    const okResponse = response as DarkVenueHeatmapApiOkResponse;

    if (!okResponse.venueWeights) {
        return fail('Unexpected response from API (no "weights" returned)');
    }
    if (okResponse.venueWeights.length < 1) {
        return fail(`No weights returned from API`);
    }

    return { isValid: true };
}
